module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-pick__sidebar"
  }, _vm._l((_vm.selfShortcuts), function(item, index) {
    return _c('t-button', {
      key: index,
      staticClass: "btn-block mb-2",
      attrs: {
        "type": "secondary"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$_onButtonsClick(item.onClick)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa7d37f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/date-picker/panel/shortcuts-aside.vue
// module id = 401
// module chunks = 0